import { selectUserDetails } from "../../redux/slices/auth"
import {
  useFetchLoanOfficerQuery,
  useFetchOrgDetailsQuery
} from "../../redux/queries"
import { Integration } from "../../types"
import { useAppSelector } from "./use-store"

/**
 * Resolves the org that owns `integration`, fetching the owner's org when an
 * administrator is creating/editing on behalf of another user whose
 * `org_id`/`brand_id` aren't yet known — so `targetOrgId` still reflects that
 * owner's brand instead of falling back to the viewer's own org.
 */
export const useIntegrationOwnerOrg = (
  integration: Integration | undefined,
  formOwnerId: string | undefined
) => {
  const user = useAppSelector(selectUserDetails)
  const ownerId = formOwnerId || user?.id || ""
  const isCurrentUser = ownerId === user?.id
  const needsOwnerFetch = !integration?.brand_id && !isCurrentUser && !!ownerId

  const { data: ownerData } = useFetchLoanOfficerQuery(ownerId, {
    skip: !needsOwnerFetch
  })
  const { data: ownerOrg } = useFetchOrgDetailsQuery(
    { id: String(ownerData?.org_id ?? "") },
    { skip: !needsOwnerFetch || !ownerData?.org_id }
  )

  const targetOrgId = integration?.org_id ?? ownerOrg?.id ?? user?.org?.id

  return { user, ownerId, isCurrentUser, ownerOrg, targetOrgId }
}
